import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import Tag from './Tag';
import { getTags } from '../queries/queries.js';

const TagsList = ({ tagRepoName, TagRepoOwner }) => {
  const { data, loading, error } = useQuery(getTags, {
    variables: {
      name: tagRepoName,
      owner: TagRepoOwner,
    },
  });

  if (loading) {
    return <div style={{ textAlign: 'center' }}>loading tags...</div>;
  } else if (error) {
    return <div>{error}</div>;
  }

  if (!data.repository.refs.nodes.length) {
    return (
      <div
        style={{
          // background: 'crimson',
          // background: 'rgba(253, 187, 187, 0.8)',
          background: 'rgba(255, 212, 212, 0.8)',
          margin: '10px 0px 0px 10px',
          textAlign: 'center',
          color: 'black',
        }}
      >
        There are no tags!
      </div>
    );
  }

  return (
    <div className="issues">
      <h4>Tags: </h4>
      {data.repository.refs.nodes.map((ref) => (
        <li key={ref.id}>
          <Tag name={ref.name} />
        </li>
      ))}
    </div>
  );
};

export default TagsList;
